<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container grid-list-xl fluid v-else>
            <v-row>
                <v-col lg="12">
                    <data-table
                        ref="tableEmpresas"
                        :tableName="'Empresas'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :perPage="[10, 25, 50, 100]"
                        :showAdvancedFilters="rol == 'root' ? true : false"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar" style="padding-right: 12px;" v-if="permisos.create">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>
                        <template slot="filters">
                            <v-row>
                                <v-col cols="12" md="12" lg="12" class="py-0">
                                    <v-text-field
                                    label="Nombre"
                                    outlined
                                    v-model="advancedSearch.nombre"/>
                                </v-col>
                                <v-col cols="12" md="12" lg="12" class="py-0">
                                    <v-text-field
                                    label="Razón Social"
                                    outlined
                                    v-model="advancedSearch.razon_social"/>
                                </v-col>
                                <v-col cols="12" md="6" lg="6" class="py-0">
                                    <v-autocomplete
                                    label="Cliente"
                                    :items="clientes"
                                    item-text="nombre"
                                    item-value="id"
                                    outlined
                                    v-model="cliente_value"/>
                                </v-col>
                                <v-col cols="12" md="6" lg="6" class="py-0">
                                    <v-text-field
                                    label="RFC"
                                    outlined
                                    v-model="advancedSearch.rfc"/>
                                </v-col>
                            </v-row>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td v-if="rol == 'root'">
                                    <div class="tblPrincipal">{{ item.nombre }}</div>
                                </td>

                                <td v-if="rol == 'admin'">
                                    <div class="tblPrincipal">{{ item.nombre }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.razon_social }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.rfc }}</div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    small
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones"
                                                    >edit</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom v-if="permisos.delete">
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    small
                                                    fab
                                                    dark
                                                    @click="eliminar(item.id, item.nombre)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template>
            <v-layout row justify-center>
                <v-dialog v-model="dialog" persistent max-width="700px" scrollable>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>

                    <perfect-scrollbar style="background:#FFF">
                        <v-card elevation="0">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="datosEmpresa.logo" class="imgModal" />
                                    <h2 class="titleModal">{{ titulo_modal }}</h2>
                                </div>
                            </v-card-title>

                            <v-card-text class="card_texto">
                                <div id="loadingModal" v-show="!finaliza_carga">
                                    <div id="loading">
                                        <v-progress-circular
                                            indeterminate
                                            :size="100"
                                            :width="7"
                                            color="blue"
                                        ></v-progress-circular>
                                    </div>
                                </div>

                                <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>
                                    <v-row>
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Nombre"
                                                v-model="datosEmpresa.nombre"
                                                v-validate="'required'"
                                                data-vv-name="Nombre"
                                                :error-messages="errors.collect('Nombre')"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Razón social"
                                                v-model="datosEmpresa.razon_social"
                                                required
                                                v-validate="'required'"
                                                data-vv-name="Razón social"
                                                :error-messages="errors.collect('Razón social')"
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="RFC"
                                                v-model="datosEmpresa.rfc"
                                                required
                                                id="RFC"
                                                maxlength="18"
                                                v-validate="'required|rfc'"
                                                data-vv-name="RFC"
                                                :error-messages="errors.collect('RFC')"
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Código postal"
                                                v-model="busca_cp"
                                                v-validate="'required'"
                                                data-vv-name="Código postal"
                                                :error-messages="errors.collect('Código postal')"
                                                @keyup.enter="busca_codigos()"
                                                v-on:keydown.tab="busca_codigos()"
                                                v-mask="'#####'"
                                            />
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Estado"
                                                v-model="estado"
                                                disabled
                                            />
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Municipio"
                                                v-model="municipio"
                                                disabled
                                            />
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="6" md="8" lg="8" xl="8" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Dirección"
                                                v-model="datosEmpresa.direccion"
                                                required
                                                v-validate="'required'"
                                                data-vv-name="Dirección"
                                                :error-messages="errors.collect('Dirección')"
                                            />
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="colonias"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Colonia"
                                                persistent-hint
                                                v-model="datosEmpresa.colonia_id"
                                                v-validate="'required'"
                                                data-vv-name="Colonia"
                                                :error-messages="errors.collect('Colonia')"
                                            >
                                                <template v-if="mColonia"  v-slot:append-item>
                                                    <v-list-item>             
                                                        <v-list-item-content class="cursor-pointer"  @click="abrirModalColonia()">
                                                            <v-list-item-title style="color:#007EFF">Agregar colonia</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                            <v-text-field 
                                                outlined 
                                                label="Calle" 
                                                class="pa-0 ma-0" 
                                                v-model="datosEmpresa.calle" 
                                                v-validate="'required'"
                                                data-vv-name="Calle"
                                                :error-messages="errors.collect('Calle')"
                                            >                                                
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                            <v-text-field 
                                                outlined 
                                                label="Número interior" 
                                                class="pa-0 ma-0" 
                                                v-model="datosEmpresa.interior"
                                                v-validate="'required'"
                                                data-vv-name="Número interior"
                                                :error-messages="errors.collect('Número interior')"
                                            >                                            
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Teléfono" 
                                                v-mask="'(###) ###-####'"
                                                v-model="datosEmpresa.telefono_contacto" 
                                                v-validate="'required'"
                                                data-vv-name="Teléfono"
                                                :error-messages="errors.collect('Teléfono')"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                            <v-text-field 
                                                outlined 
                                                label="Apoderado" 
                                                class="pa-0 ma-0" 
                                                v-model="datosEmpresa.apoderado" 
                                                v-validate="'required'"
                                                data-vv-name="Apoderado"
                                                :error-messages="errors.collect('Apoderado')"
                                            >                                               
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" v-if="logoEmpresa == false" class="py-0">
                                            <v-text-field 
                                                outlined 
                                                label="URL de Servidor" 
                                                v-model="datosEmpresa.url_server_asp" 
                                                required 
                                                v-validate="'https_puerto'" 
                                                data-vv-name="URL de Servidor" 
                                                :error-messages="errors.collect('URL de Servidor')"
                                            ></v-text-field>
                                        </v-col>
                                        <template v-if="rol == 'root'">
                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <v-autocomplete
                                                    outlined
                                                    :items="clientes"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Cliente"
                                                    persistent-hint
                                                    v-model="datosEmpresa.cliente_id"
                                                    v-validate="'required'"
                                                    data-vv-name="Cliente"
                                                    :error-messages="errors.collect('Cliente')"
                                                ></v-autocomplete>
                                            </v-col>
                                        </template>

                                        <v-col cols="12" xs="12" sm="5" md="5" lg="5" xl="5" v-if="logoEmpresa" class="py-0">
                                            <v-text-field 
                                                outlined 
                                                label="URL de Servidor" 
                                                v-model="datosEmpresa.url_server_asp" 
                                                required 
                                                v-validate="'https_puerto'" 
                                                data-vv-name="URL de Servidor" 
                                                :error-messages="errors.collect('URL de Servidor')"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col v-if="accion=='add'" cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0 ma-0">
                                            <v-text-field
                                                outlined
                                                readonly
                                                label="Seleccionar logo"
                                                @click="almacenarImagen"
                                                v-model="nombreImagen"
                                            >
                                                <template slot="append">
                                                    <v-icon @click="almacenarImagen" class="tamIcono">attach_file</v-icon>
                                                </template>
                                            </v-text-field>
                                            <input
                                                type="file"
                                                style="display: none"
                                                ref="imagen"
                                                accept="image/*"
                                                id="avatar"
                                                @change="onFilePickedImagen"
                                            />
                                        </v-col>
                                        <v-col v-if="accion=='update' && logoEmpresa == false" cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0 ma-0">
                                            <v-text-field
                                                outlined
                                                readonly
                                                label="Seleccionar logo"
                                                @click="almacenarImagen"
                                                v-model="nombreImagen"
                                            >
                                            <template slot="append">
                                                <v-icon @click="almacenarImagen" class="tamIcono">attach_file</v-icon>
                                            </template>
                                            </v-text-field>
                                            <input
                                                type="file"
                                                style="display: none"
                                                ref="imagen"
                                                accept="image/*"
                                                id="avatar"
                                                @change="onFilePickedImagen"
                                            />
                                        </v-col>
                                        <v-col v-if="accion=='update' && logoEmpresa" cols="12" xs="12" sm="5" md="5" lg="5" xl="5" class="pt-0 pb-0 ma-0">
                                            <v-text-field
                                                outlined
                                                readonly
                                                label="Seleccionar logo"
                                                @click="almacenarImagen"
                                                v-model="nombreImagen"
                                            >
                                            <template slot="append">
                                                <v-icon @click="almacenarImagen" class="tamIcono">attach_file</v-icon>
                                            </template>
                                            </v-text-field>
                                            <input
                                                type="file"
                                                style="display: none"
                                                ref="imagen"
                                                accept="image/*"
                                                id="avatar"
                                                @change="onFilePickedImagen"
                                            />
                                        </v-col>
                                        <v-col v-if="accion=='update' && logoEmpresa" cols="12" xs="12" sm="1" md="1" lg="1" xl="1" class="pt-2">
                                            <v-btn
                                                class="botonHover"
                                                icon
                                                fab
                                                dark
                                                small
                                                @click="eliminarLogo()"
                                            >
                                                <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                            </v-btn>
                                        </v-col>
                                        
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <v-textarea
                                                outlined
                                                label="Actividad comercial"
                                                v-model="datosEmpresa.actividad_comercial"
                                                v-validate="'required'"
                                                data-vv-name="Actividad comercial"
                                                :error-messages="errors.collect('Actividad comercial')"
                                                rows="3"
                                            ></v-textarea>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <v-textarea
                                                v-model="direccionContrato"
                                                outlined
                                                label="Dirección contrato"
                                                rows="3"
                                                v-validate="'required'"
                                                data-vv-name="Dirección contrato"
                                                :error-messages="errors.collect('Dirección contrato')"
                                            ></v-textarea>
                                        </v-col>

                                        <!-- <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <div>
                                                <p class="texto">Otras acciones</p>
                                            </div>
                                            <div class="d-flex">
                                                <v-checkbox class="pa-0 ma-0 checkboxVuetify"  label="Generar dos contratos" v-model="datosEmpresa.activar_dos_contratos">    
                                                </v-checkbox>
                                                <v-tooltip top class="pb-7">
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon color='#96999A' v-on="on" slot="activator" class="pb-7 pl-2 outlined_v_icon">info</v-icon>
                                                    </template>
                                                    <span class="pb-7 textTooltip">
                                                        Se genera dos contratos, por ejemplo: <br>
                                                        un contrato por tiempo determinado y <br>
                                                        otro por tiempo indeterminado
                                                    </span>
                                                </v-tooltip> 
                                            </div>
                                        </v-col> -->
                                        <!-- <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                            <v-divider></v-divider>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pt-5">
                                            <p class="subtitulo">Datos Fiscales</p>
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Representante legal"
                                                v-model="datosEmpresa.representante_legal"
                                                v-validate="'required'"
                                                data-vv-name="Representante legal"
                                                :error-messages="errors.collect('Representante legal')"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                label="Método de pago"
                                                :items="metodosPagos"
                                                item-text="nombre"
                                                item-value="id"
                                                persistent-hint
                                                v-model="datosEmpresa.metodo_de_pago_id"
                                                class="pa-0 ma-0"
                                                v-validate="'required'"
                                                data-vv-name="Método de pago"
                                                :error-messages="errors.collect('Método de pago')"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                label="Banco"
                                                :items="bancos"
                                                item-text="nombre"
                                                item-value="id"
                                                persistent-hint
                                                v-model="datosEmpresa.banco_empresa_f_id"
                                                class="pa-0 ma-0"
                                                v-validate="'required'"
                                                data-vv-name="Banco"
                                                :error-messages="errors.collect('Banco')"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <VuetifyDatePicker
                                                outlined
                                                v-model="datosEmpresa.inicio_operaciones"
                                                label="Inicio de operaciones"
                                                placeholder="dd/mm/aaaa"
                                                ref="FechaInicioOperaciones"
                                            />
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <VuetifyDatePicker
                                                    outlined
                                                    v-model="datosEmpresa.fecha_contrato"
                                                    label="Fecha de contrato"
                                                    placeholder="dd/mm/aaaa"
                                                    ref="FechaInicioContrato"
                                                />
                                        </v-col> -->
                                        
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                                <button class="btnCerrar" @click="cerrarModal()" :disabled="loading_guardar">
                                    Cancelar
                                </button>
                                <v-btn 
                                    class="btnGuardar" 
                                    @click="guardar()" 
                                    :loading="loading_guardar"
                                    v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')"
                                >
                                    Guardar
                                </v-btn>
                            </v-card-actions>
                            <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                                <v-alert
                                    dense
                                    outlined
                                    type="error"
                                    
                                >
                                    El usuario no tiene permiso para editar el registro.
                                </v-alert>
                            </div>
                        </v-card>
                    </perfect-scrollbar>
                </v-dialog>
            </v-layout>
        </template>
         <!--MODAL COLONIA FORM-->
         <template class="borde-card">
            <v-dialog v-model="dialogColonia" persistent max-width="500px" class="borde-card">
                <v-card class="borde-card">
                    <ValidationObserver ref="formColonia" v-slot="{invalid}">

                            <v-card-title class="card_titulo padding_izquierdo padding_derecho">
                                <div class="headerModalStart">
                                    <h2 class="titleModal_700_18">Agregar colonia</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto mt-5">
                            <div id="padre" v-show="isLoadingModalColonia">
                                <div id="loading">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </div>
                            </div>
                            <v-container v-show="!isLoadingModalColonia" grid-list-md id="contenedor">
                                <v-row class="mt-0">
                                    <v-col cols="12" xs="12" sm="12" md="12" class="pt-0 pb-0 ma-0">
                                        <ValidationProvider v-slot="{ errors }" name="Código postal" rules="required">
                                            <v-text-field 
                                                outlined
                                                label="Código postal" 
                                                class="pa-0 ma-0" 
                                                v-model="busca_cp" 
                                                :error-messages="errors" 
                                                required
                                                disabled
                                            >
                                            </v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="12" class="pt-0 pb-0 ma-0">
                                        <ValidationProvider v-slot="{ errors }" name="Colonia" rules="required">
                                            <v-text-field 
                                                outlined
                                                label="Colonia" 
                                                class="pa-0 ma-0" 
                                                v-model="nombreColonia" 
                                                :error-messages="errors" 
                                                required
                                            >
                                            </v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button
                                class="btnCerrar"
                                @click="cerrarModalColonia()"
                                :disabled="isSavingColonia">
                                Cancelar
                            </button>
                            <v-btn
                                class="btnGuardar"
                                @click="guardarColonia()"
                                :disabled="invalid"
                                :loading="isSavingColonia">
                                Guardar
                            </v-btn>
                        </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Swal from "sweetalert2";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import empresasApi from "../api/empresas";
import catalogoApis from "../api/catalogos";
import clientesApi from "../api/clientes";
import Notify from "@/plugins/notify";
import GetUrlImg from "@/plugins/Urlimagen";
import Datatable from "@/components/datatable/Datatable.vue";
import PerfectScrollbar from "perfect-scrollbar";
import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';
import apiBancos from "@/api/bancos";
import apiMetodoPago from "@/api/metodoPago";

export default {
    components: {
        "data-table": Datatable,
        VuetifyDatePicker
    },
    data() {
        return {
            url: "empresas/find",
            columns: [
                { label: "Nombre", name: "nombre", filterable: true },
                { label: "Razón social", name: "razon_social", filterable: true },
                { label: "RFC", name: "rfc", filterable: true },
                { label: "Opciones", name: "opciones", filterable: false, align: 'center'},
            ],
            filters: {
                activo          : true,
                paginate        : true,
                include_padres  : true,
                cliente_id      : null,
                razon_social    : null,
                rfc             : null,
                nombre          : null,
                order_by        : 'nombre',
            },
            loading_guardar     : false,
            dialog              : false,
            datosLogin          : "",
            nombre_archivo      : "",
            datosEmpresa        : {
                id                  : null,
                nombre              : null,
                razon_social        : null,
                rfc                 : null,
                direccion           : null,
                estado_id           : null,
                municipio_id        : null,
                cp_id               : null,
                colonia_id          : null,
                cliente_id          : null,
                url_server_asp      : null,
                logo                : null,
                update_logo         : null,
                telefono_contacto   : null,
                representante_legal : null,
                metodo_de_pago_id   : null,
                banco_empresa_f_id  : null,
                inicio_operaciones  : null,
                fecha_contrato      : null,
                calle               : null,
                interior            : null,
                apoderado           : null,
                actividad_comercial : null,
                //activar_dos_contratos: false,
            },
            cliente_value       : null,
            colonias            : [],
            titulo_modal        : "",
            finaliza_carga      : false,
            parametros_base     : { activo: true, paginate: false, order: "asc" },
            accion              : "",
            rol                 : "",
            clientes            : [],
            estado              : "",
            conteo_parametros   : 0,
            urlImg              : null,
            nombreImagen        : "",
            archivoImagen       : null,
            busca_cp            : "",
            municipio           : "",
            estado              : "",
            logoEmpresa         : false,
            bancos              : [],
            metodosPagos        : [],
            direccionContrato   : "",
             //Modal Colonia
            dialogColonia           : false,
            isLoadingModalColonia   : true,
            nombreColonia           : null,
            isSavingColonia         : false,
            mColonia                : false,
            permisos :{
                create: false,
                update: false,
                delete: false,
            },
            advancedSearch: {
                nombre: null,
                rfc: null,
                razon_social: null
            }
        };
    },
    watch:{
        'datosEmpresa.calle':function(val){
            this.formatoDireccionContrato();
        },
        'datosEmpresa.interior':function(val){
            this.formatoDireccionContrato();
        },
        'datosEmpresa.colonia_id':function(val){
            this.formatoDireccionContrato();
        },
        'estado':function(val){
            this.formatoDireccionContrato();
        },
        'municipio':function(val){
            this.formatoDireccionContrato();
        },
        busca_cp: function(val){
            if (val != null){
                if(val.length == 5){
                    this.busca_codigos();
                    this.formatoDireccionContrato();
                    this.mColonia = true
                }
                else{
                    this.estado = "";
                    this.municipio = "";
                    this.colonias = [];
                    this.mColonia = false
                }
            }
        }
    },
    methods: {
        formatoDireccionContrato(){
            let colonia = this.colonias.find(element => element.id == this.datosEmpresa.colonia_id);
            let nombreColonia = "";
            if(colonia != undefined){
                nombreColonia = colonia.nombre!=undefined ? colonia.nombre : '';
            }
            if(this.accion == 'add'){
                this.direccionContrato = ("CALLE "+this.datosEmpresa.calle + " NÚMERO " + this.datosEmpresa.interior + " DE LA COLONIA " + nombreColonia + " CÓDIGO POSTAL " + this.busca_cp + " " + this.municipio  + ", " + this.estado).toUpperCase()
            }
        },
        busca_codigos() {
            let self = this;
            let params = {
                activo: true,
                nombre: this.busca_cp,
                include_padres: true,
            };
            catalogoApis.getCP(params).then((response) => {
                let result = response.data;

                if (result.length == 0) {
                    Notify.ErrorToast("No se encontro el Código postal.");
                    this.estado = "";
                    this.municipio = "";
                    this.colonias = [];
                    this.mColonia = false;
                    return;
                }
                this.estado = result[0].nomb_estado;
                this.municipio = result[0].nomb_mun;
                this.datosEmpresa.estado_id = result[0].estado_id;
                this.datosEmpresa.municipio_id = result[0].municipio_id;
                this.datosEmpresa.cp_id = result[0].id;

                catalogoApis.getColonias({ codigo_postal_id: result[0].id, order: "asc", paginate: false }).then((response) => {
                    self.colonias = response.data;
                        if (self.accion == "update") {
                            self.finaliza_carga = true;
                        }
                    })
                    .catch((e) => {
                        Notify.ErrorToast("Se presento un problema al cargar las colonias.");
                        return;
                    });
                })
                .catch((e) => {
                    console.log(e);
                    Notify.ErrorToast(
                        "Ocurrió un error al cargar los estados y ciudades."
                    );
                });
        },
        async getCP(id) {
            await catalogoApis.getCodigoPostal(id).then((response) => {
                this.busca_cp = response.nombre;
                this.busca_codigos();
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los codigos postales.");
            });
        },
        eliminar(id, empresa) {
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que seas eliminar la empresa?",
                "Eliminar",
                () => {
                    empresasApi.deleteEmpresa(id).then((response) => {
                        this.$refs.tableEmpresas.getData();
                        this.respuesta_ok("La empresa ha sido eliminado satisfactoriamente");
                    })
                    .catch((err) => {
                        console.log(err);
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            );
        },
        listar() {
            this.urlImg = GetUrlImg.getURL();

            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;

            if (this.rol == "admin") {
                this.filters.cliente_id = this.datosLogin.cliente_id;
            }
        },
        setFilters() {
            let cliente = null;

            if (this.rol == "admin") {
                cliente = this.datosLogin.cliente_id;
            }else if(this.rol == "root"){
                cliente = this.cliente_value;
            }

            this.filters.cliente_id = cliente;
            this.filters.nombre = this.advancedSearch.nombre
            this.filters.razon_social = this.advancedSearch.razon_social
            this.filters.rfc = this.advancedSearch.rfc

            this.$refs.tableEmpresas.getData();
        },

        loadModalData() {
            this.resetValue();
            this.getClientes();
        },
        async abrirModal(accion, item = null) {
            this.errors.clear();
            this.resetValue();
            this.accion = accion;
            this.getBancos();
            this.getMetodosPagos();

            if (accion == "add") {
                this.titulo_modal = "Registro empresa";
                this.datosEmpresa.logo = "/static/modal/empresaSucursalCreate.svg";
                this.logoEmpresa = false;

                if (this.rol == "root" || this.rol == "admin") {
                    this.getClientes();
                }
            } else {
                this.titulo_modal       = "Actualizar empresa";
                this.datosEmpresa.logo  = item.logo;

                if (item.logo == null) {
                    this.datosEmpresa.logo = "/static/modal/empresaSucursalUpdate.svg";
                    this.logoEmpresa = false;
                    
                } else {
                    this.datosEmpresa.update_logo = item.logo;
                    this.datosEmpresa.logo = this.urlImg + item.logo;
                    this.logoEmpresa = true;
                }
                this.datosEmpresa.id                    = item.id;
                this.datosEmpresa.nombre                = item.nombre;
                this.datosEmpresa.razon_social          = item.razon_social;
                this.datosEmpresa.rfc                   = item.rfc;
                this.datosEmpresa.direccion             = item.direccion;
                this.datosEmpresa.url_server_asp        = item.url_server_asp;
                this.estado                             = item.nombre_estado;
                this.municipio                          = item.nombre_municipio;
                this.datosEmpresa.colonia_id            = item.colonia_id;
                this.datosEmpresa.telefono_contacto     = item.telefono_contacto;
                this.datosEmpresa.representante_legal   = item.representante_legal;
                this.datosEmpresa.metodo_de_pago_id     = item.metodo_de_pago_id;
                this.datosEmpresa.banco_empresa_f_id    = item.banco_empresa_f_id;
                this.datosEmpresa.inicio_operaciones    = item.inicio_operaciones;
                this.datosEmpresa.fecha_contrato        = item.fecha_contrato;
                this.datosEmpresa.calle                 = item.calle;
                this.datosEmpresa.interior              = item.interior;
                this.datosEmpresa.apoderado             = item.apoderado;
                this.datosEmpresa.actividad_comercial   = item.actividad_comercial;
                this.direccionContrato                  = item.direccion_contrato;
                //this.datosEmpresa.activar_dos_contratos = item.activar_dos_contratos;                

                /* setTimeout(()=>this.$refs.FechaInicioOperaciones.setDate(item.inicio_operaciones),200);
                setTimeout(()=>this.$refs.FechaInicioContrato.setDate(item.fecha_contrato),200); */
                await this.getCP(item.cp_id);

                if (this.rol == "root" || this.rol == "admin") {
                    this.getClientes();
                    this.datosEmpresa.cliente_id = item.cliente_id;
                }
            }
            setTimeout(function() {
                document.getElementById("btnModal").click();
            }, 100);
        },

        getClientes(cliente_id = null) {
            let self = this;
            clientesApi.getClientes(this.parametros_base).then((response) => {
                self.clientes = response.data;
                self.finaliza_parametros();
            })
            .catch((err) => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        finaliza_parametros() {
            this.finaliza_carga = true;
            this.conteo_parametros = this.conteo_parametros + 1;
            if (this.conteo_parametros == 2 && this.accion == "add") {
                this.finaliza_carga = true;
            }
            if (this.conteo_parametros == 3 && this.accion == "update") {
                this.finaliza_carga = true;
            }
        },
        guardar() {
            this.$validator.validate().then((result) => {
                if (result) {
                    this.loading_guardar = true;
                    this.datosEmpresa.rfc = this.datosEmpresa.rfc.toUpperCase();
                    let formData = new FormData();

                    if (this.archivoImagen != null) {
                        formData.append("archivo", this.archivoImagen);
                        if (this.datosEmpresa.update_logo != null) {
                            formData.append("update_logo", this.datosEmpresa.update_logo);
                        }
                    }

                    if (this.rol == "admin") {
                        this.datosEmpresa.cliente_id = this.datosLogin.cliente_id;
                    }

                    formData.append("nombre", this.datosEmpresa.nombre.toString());
                    formData.append("razon_social",this.datosEmpresa.razon_social.toString());
                    formData.append("rfc", this.datosEmpresa.rfc.toString());
                    formData.append("direccion", this.datosEmpresa.direccion.toString());
                    formData.append("estado_id", this.datosEmpresa.estado_id);
                    formData.append("municipio_id", this.datosEmpresa.municipio_id);
                    formData.append("cp_id", this.datosEmpresa.cp_id);
                    formData.append("colonia_id", this.datosEmpresa.colonia_id);
                    formData.append("calle", this.datosEmpresa.calle);
                    formData.append("interior", this.datosEmpresa.interior);
                    formData.append("apoderado", this.datosEmpresa.apoderado);
                    formData.append("actividad_comercial", this.datosEmpresa.actividad_comercial.toString());
                    formData.append("tipo", "gdth");
                    //formData.append("activar_dos_contratos",this.datosEmpresa.activar_dos_contratos)

                    if(this.direccionContrato != null && this.direccionContrato != ''){
                        formData.append('direccion_contrato', this.direccionContrato.toString());
                    }
                    if(this.datosEmpresa.telefono_contacto != "" && this.datosEmpresa.telefono_contacto != null){
                        formData.append("telefono_contacto", this.datosEmpresa.telefono_contacto);
                    }
                    if(this.datosEmpresa.inicio_operaciones != "" && this.datosEmpresa.inicio_operaciones != null){
                        formData.append("inicio_operaciones", this.datosEmpresa.inicio_operaciones);
                    }
                    if(this.datosEmpresa.fecha_contrato != "" && this.datosEmpresa.fecha_contrato != null){
                        formData.append("fecha_contrato", this.datosEmpresa.fecha_contrato);
                    }
                    if(this.datosEmpresa.representante_legal != "" && this.datosEmpresa.representante_legal != null){
                        formData.append("representante_legal", this.datosEmpresa.representante_legal);
                    }
                    if(this.datosEmpresa.metodo_de_pago_id != "" && this.datosEmpresa.metodo_de_pago_id != null){
                        formData.append("metodo_de_pago_id", this.datosEmpresa.metodo_de_pago_id);
                    }
                    if(this.datosEmpresa.banco_empresa_f_id != "" && this.datosEmpresa.v != null){
                        formData.append("banco_empresa_f_id", this.datosEmpresa.banco_empresa_f_id);
                    }
                    
                    

                    if(this.datosEmpresa.url_server_asp != "" && this.datosEmpresa.url_server_asp != null){
                        formData.append( "url_server_asp", this.datosEmpresa.url_server_asp.toString());
                    }
                
                    formData.append("cliente_id", this.datosEmpresa.cliente_id);

                    if (this.accion === "add") {
                        empresasApi.addEmpresa(formData).then((response) => {
                            this.respuesta_ok("Se ha creado la empresa correctamente");
                            this.$refs.tableEmpresas.getData();
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    } 
                    else if (this.accion === "update") {
                        formData.append("id", this.datosEmpresa.id);
                        empresasApi.updateEmpresaP(formData).then((response) => {
                            this.respuesta_ok("Se ha realizado la actualización correctamente");
                            this.$refs.tableEmpresas.getData();
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    }
                }
            });
        },
        cerrarModal() {
            this.dialog = false;
            this.resetValue();
        },
        resetValue() {
            this.datosEmpresa = {
                id                  : null,
                nombre              : null,
                razon_social        : null,
                rfc                 : null,
                direccion           : null,
                estado_id           : null,
                municipio_id        : null,
                cp_id               : null,
                colonia_id          : null,
                cliente_id          : null,
                url_server_asp      : null,
                logo                : null,
                update_logo         : null,
                telefono_contacto   : null,
                representante_legal : null,
                metodo_de_pago_id   : null,
                banco_empresa_f_id  : null,
                inicio_operaciones  : null,
                fecha_contrato      : null,
                calle               : null,
                interior            : null,
                apoderado           : null,
                actividad_comercial : null,
                //activar_dos_contratos: false,
            };
            this.estado_id = null;
            this.loading_guardar = false;
            this.conteo_parametros = 0;
            this.clientes = [];
            this.estados = [];
            this.ciudades = [];
            this.municipios = [];
            this.codigosP = [];
            this.municipio_id = null;
            this.codigo_postal_id = null;
            this.colonia_id = null;
            this.nombreImagen = "";
            this.archivoImagen = null;
            this.busca_cp = null;
            this.cliente_value = null;
            this.colonias = [];
            this.estado = "";
            this.municipio = "";
            this.mColonia = false;
            this.advancedSearch = {
                nombre: null,
                razon_social: null,
                rfc: null,
            }

            if(this.$refs.FechaInicioOperaciones != undefined || this.$refs.FechaInicioOperaciones != null){
                this.$refs.FechaInicioOperaciones.resetDate();
            }
            if(this.$refs.FechaInicioContrato != undefined || this.$refs.FechFechaInicioContratoaFinal != null){
                this.$refs.FechaInicioContrato.resetDate();
            }
        },
        respuesta_error(err) {
            this.loading_guardar = false;
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj = "") {
            this.listar();
            this.cerrarModal();
            Notify.Success("Operación exitosa", msj);
        },
        almacenarImagen() {
            this.$refs.imagen.click();
        },
        onFilePickedImagen(evento) {
            const img = evento.target.files;
            if (img[0] !== undefined) {
                this.nombreImagen = img[0].name;
                if (this.nombreImagen.lastIndexOf(".") <= 0) {
                return;
                }
                const archivo = new FileReader();
                archivo.readAsDataURL(img[0]);
                archivo.addEventListener("load", () => {
                this.archivoImagen = img[0];
                });
            } else {
                this.nombreImagen = "";
                this.archivoImagen = null;
            }
        },
        init() {
            const elementScroll = document.querySelector("#scroll");
            if (elementScroll) {
                const ps = new PerfectScrollbar(elementScroll, {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollY: true,
                });
            }
            $(".ps__thumb-x").css("position", "fixed");
        },
        eliminarLogo(){
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el logo de la empresa?",
                "Eliminar",
                () => {
                    let param = {id:this.datosEmpresa.id, rol_name:"admin-empresa"};
                    empresasApi.deleteLogo(param).then(response => {
                        Notify.Success("Logo eliminado", "El logo ha sido eliminado satisfactoriamente");
                        this.datosEmpresa.logo = "/static/modal/empresaSucursalUpdate.svg";
                        this.logoEmpresa = false;
                    })
                    .catch(err => {
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            )           
        },
        getBancos(){
            let parametros = { activo:true, paginate:false, order:"asc" }
            apiBancos.find(parametros).then((response) => {
                this.bancos = response.data;
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los Bancos.");
            });
        },
        getMetodosPagos(){
            let parametros = { activo:true, paginate:false, order:"asc" }
            apiMetodoPago.find(parametros).then((response) => {
                this.metodosPagos = response.data;
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los Métodos de Pagos.");
            });
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },

        //Modal Colonia
        abrirModalColonia(){
            this.dialogColonia = true
            this.isLoadingModalColonia = false
        },

        cerrarModalColonia(){
            this.dialogColonia = false
            this.nombreColonia = null
            this.isSavingColonia = false
        },
        guardarColonia(){
            this.$refs.formColonia.validate().then(success => {
                this.isSavingColonia = true;
                if(!success){
                    this.isSavingColonia = false;
                    return
                }

                let parametros = {
                    nombre: this.nombreColonia,
                    codigo_postal_id: this.datosEmpresa.cp_id
                }

                catalogoApis.addColonia(parametros).then((res)=>{
                    Notify.Success("Operación exitosa", "La colonia se agrego correctamente")
                    this.busca_codigos()
                    this.cerrarModalColonia()
                    this.datosEmpresa.colonia_id = res.data.id
                    this.$nextTick(()=>{
                        this.$refs.formColonia.reset()
                    })
                }).catch(err =>{
                    this.isSavingColonia = false
                    if(typeof err.response.data.error === 'string'){
                        Notify.ErrorToast(err.response.data.error)
                    }else{
                        let error = Object.values(err.response.data.error)
                        let leyenda = ``

                        for(var i=0; i < error.length; i++){
                            leyenda += `*` + error[i] + `\n`
                        }
                        Notify.ErrorToast(leyenda)
                    }
                })
            })
        },
        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("empresas.store")
            this.permisos.update = permisosStorage.includes("empresas.update")
            this.permisos.delete = permisosStorage.includes("empresas.delete")
        }
    },
    mounted() {
        this.init();
    },
    created() {
        this.listar();
        this.permisosVista();
    },
};
</script>
<style scoped>
    #RFC {
        text-transform: uppercase !important;
    }
    .subtitulo{
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #1E2245;
    }
    .texto{
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #828282;
    }

    .cursor-pointer{
        cursor:pointer;
    }

</style>
